import { Guid } from "@/Common/Models/Guid";

class PrescriptionPrintHistory {
    public Id: Guid;
    public EmployeeId: Guid;
    public PrescriptionId: Guid;
    public PrintDate: Date;

    constructor(init: Partial<PrescriptionPrintHistory>) {
        Object.assign(this, init);
    }
}

export { PrescriptionPrintHistory };
